import { toast } from 'react-toastify'
import { useAuthContext } from '../Context/AuthContext'
import { useRequest } from '../Context/RequestContext'

const useAuth = () => {
    const { login, user } = useAuthContext()
    const { Request } = useRequest();

    const onAuth = async (data, url) => {
        await Request({ data, url }).then((response) => {
            if (response.status === 200) {
                login(response.data)
            } else {
                toast.error(response.statusText);
            }
        })
    }

    const editProfile = async (data) => {
        await Request({ data, url: "/admin/editprofile" }).then((response) => {
            if (response.status === 200) {
                toast.success('اطلاعات شما با موفقیت ویرایش شد !');
                login({ ...user, ...response.data })
            } else {
                toast.error(response.statusText);
            }
        })
    }

    return { onAuth, user, editProfile }

}

export default useAuth